import { useGetSession } from "@/api/auth/queries";
import { useGlobalStore } from "@/stores/global-store";
import { ReactNode, useEffect } from "react";
import { usePostHog } from "@posthog/react";

/**
 * Permissions Provider
 *
 * This provider is responsible for managing user permissions
 * and making them available throughout the application.
 */
export const PermissionsProvider = ({ children }: { children: ReactNode }) => {
  /* Queries */
  const { data: session } = useGetSession();
  const posthog = usePostHog();

  /* Stores */
  const { setEntitlements } = useGlobalStore((state) => state.appActions);

  /* Effects */
  useEffect(() => {
    if (session && session.features) {
      // Session payload still uses "features", but we model them as entitlements in-app.
      setEntitlements(session.features);
    }
  }, [session, setEntitlements]);

  useEffect(() => {
    if (!session?.user?.id) return;

    // Identify the user in PostHog for analytics purposes
    posthog.identify(session.user.id, {
      email: session.user.email,
      name: session.user.firstName + " " + session.user.lastName,
      accountId: session.account?.id,
      role: session.role,
    });
  }, [posthog, session]);

  return children;
};
